import React, { Fragment, useEffect, useState } from 'react';
import GeoApi from '../api/destinations';

export default function IataCode({ code, upperCase = false, fullName, concatStart = '' }) {
  if (!code || code === '') return null;
  const [city, setCity] = useState(null);

  useEffect(() => {
    if (code && code.length === 3) {
      GeoApi.getCityByCode(code)
        .then((res) => setCity(res))
        .catch((err) => console.error(err));
    }
  }, []);

  const theResult = () => {
    let humanised = code;
    if (city) {
      if (fullName) {
        humanised = `${city.name}, ${city.countryName}`;
      } else {
        humanised = city.name;
      }
      if (upperCase) {
        humanised = humanised.toUpperCase();
      }
    }
    return humanised;
  };
  return <Fragment>{`${concatStart} ${theResult()}`}</Fragment>;
}
